<template>
    <div class="personal-center">
        <person-left-tab :list="tabList" @change="tabChanged" />

        <div class="personal-body">
            <div class="personal-body-title">
                <span class="title">{{ bodyTitle }}</span>
                <span class="tail" v-show="bodyTitle === '账号信息' && !editingUserInfo" @click="editUserInfo">
                    <a-icon type="edit" />
                    编辑
                </span>
            </div>

            <div class="personal-body-content">
                <component
                    :is="pageName"
                    :isEdit="editingUserInfo"
                    @backView="editingUserInfo = !editingUserInfo"
                ></component>
            </div>
        </div>
    </div>
</template>

<script>
import billInfo from './components/bill-info.vue';
import cooperUser from './components/cooper-user.vue';
import PersonLeftTab from './components/person-left-tab.vue';
import personInfo from './components/person-info.vue';
import changePwd from './components/change-pwd.vue';
import addressManager from './components/address-manager.vue';

export default {
    components: { cooperUser, billInfo, PersonLeftTab, personInfo, changePwd, addressManager },
    data() {
        return {
            tabList: [
                {
                    title: '个人中心',
                    filed: 'person',
                    children: [
                        { title: '账号信息', field: 'personInfo' },
                        { title: '修改密码', field: 'changePwd' },
                        // { title: '关联账号', field: 'cooperUser' },
                        { title: '地址管理', field: 'addressManager' }
                    ]
                },
                {
                    title: '开票管理',
                    filed: 'bill',
                    children: [{ title: '开票信息', field: 'billInfo' }]
                }
            ],
            fieldMapper: {
                personInfo: '账号信息',
                changePwd: '修改密码',
                cooperUser: '关联账号',
                addressManager: '地址管理',
                billInfo: '开票信息'
            },
            bodyTitle: '',
            pageName: '',
            editingUserInfo: false
        };
    },
    methods: {
        tabChanged(field) {
            this.pageName = field;
            this.bodyTitle = this.fieldMapper[field] ?? '';
        },
        editUserInfo() {
            this.editingUserInfo = !this.editingUserInfo;
        }
    }
};
</script>

<style lang="scss" scoped>
.personal-center {
    width: 1200px;
    margin: 16px auto;
    display: flex;

    .personal-body {
        flex-grow: 1;
        margin-left: 16px;
        padding: 0 16px 16px;
        background: #ffffff;
        border: 2px solid rgba(255, 255, 255, 1);
        box-shadow: 0px 3px 14px 0px rgba(82, 126, 160, 0.07);
        border-radius: 4px;

        &-title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-family: PingFangSC-Semibold;

            .title {
                line-height: 56px;
                font-size: 20px;
                color: #333333;
                font-weight: 600;
                position: relative;
                padding-left: 8px;
                &::before {
                    content: '';
                    display: inline-block;
                    width: 3px;
                    height: 16px;
                    background-color: #2e6ddd;
                    position: absolute;
                    top: 20px;
                    left: 0;
                }
            }

            .tail {
                cursor: pointer;
                font-size: 16px;
                color: #006aff;
                text-align: center;
            }
        }
    }
}
</style>
